import styled from 'styled-components';

const HorizontalDivider = styled.div`
  background: var(--color-accent-secondary-weaker);
  height: 1px;
  margin: ${({ $margin }) => $margin};
  width: 100%;
`;

export default HorizontalDivider;
